import React from 'react';
import { Col, Row } from 'antd';
import ByMuvu from '../../../../PatientLandingGeneralComponents/ByMuvu';
import ContinueButton from '../../ContinueButton';
import ExamsStatus from './ExamsStatus';

const ExamStep = ({ stepHandler, getLocalStorageData, countryCode }) => {
  return (
    <Row justify="center">
    {
      stepHandler.status !== 'done' &&
      <Col span={24} className='mt-40'>
        <h2 className='text-center'>Toma de Exámenes</h2>
      </Col>
    }
    {
      stepHandler.status === 'done' ?
        <Col span={24}>
          <Row justify='center'>
            <Col span={24} xs={20} sm={20} lg={12} md={14} xl={10}>
            {
              stepHandler.userData &&
                <ExamsStatus
                  userData={stepHandler.userData}
                  status={stepHandler.status}
                  countryCode={countryCode}
                />
            }
            </Col>
            <Col span={24}>
              <ContinueButton
                stepHandler={stepHandler}
                getLocalStorageData={getLocalStorageData}
              />
            </Col>
            <Col span={24} className='mt-30'>
              <ByMuvu />
            </Col>
          </Row>
        </Col>
      :
        <Col span={24} className="scrollable-col">
          <div className="scrollable-content">
            <Row justify='center'>
              <Col span={24}>
              {
                stepHandler.userData &&
                  <ExamsStatus
                    userData={stepHandler.userData}
                    status={stepHandler.status}
                    countryCode={countryCode}
                  />
              }
              </Col>
              <Col span={24}>
                <ContinueButton
                  stepHandler={stepHandler}
                  getLocalStorageData={getLocalStorageData}
                />
              </Col>
              <Col span={24} className='mt-30'>
                <ByMuvu />
              </Col>
            </Row>
          </div>
        </Col>
    }
    </Row>
  );
};

export default ExamStep;
